import React, { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router';
import { message, Skeleton } from 'antd';
import MainError from '../../errors/MainError';
import ContentHeader from '../../../components/ContentHeader';
import DictionaryForm from '../../../containers/shared/DictionaryForm';
import { useTranslation } from 'react-i18next';
import routes from '../../../router/routes';
import { useEditLanguageMutation, useGetLanguageQuery } from '../../../store/apis/dictionaries/languages';
import {
  useEditLanguageLevelMutation,
  useGetLanguageLevelQuery
} from '../../../store/apis/dictionaries/languages-levels';

const Details = () => {
  const [t] = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const [edit, { isLoading }] = useEditLanguageLevelMutation();

  const {
    data: languageLevel,
    isLoading: isLanguageLevelLoading,
    isFetching: isLanguageLevelFetching,
    error: languageLevelError,
  } = useGetLanguageLevelQuery(id);

  const handleSubmit = useCallback(async (body) => {
    try {
      await edit({ id, body }).unwrap();
      message.success(t('Язык сохранен'));
    } catch (e) {
      console.log(JSON.stringify(e, 0, 2));
    }
  }, [edit, id, t]);

  const handleExit = useCallback(() => {
    navigate(routes.languageLevels());
  }, [navigate]);

  if (isLanguageLevelLoading || isLanguageLevelFetching) return <Skeleton />
  if (languageLevelError) return <MainError error={languageLevelError} />

  return (
    <div>
      <ContentHeader title={languageLevel.sysName} />
      <DictionaryForm
        onSubmit={handleSubmit}
        onExit={handleExit}
        initialValues={languageLevel}
        loading={isLoading}
        saveTitle={t('Сохранить')}
        saveAndExitTitle={t('Сохранить и выйти')}
      />
    </div>
  );
};

export default Details;
